import React, { useState, useEffect } from 'react'
import { ToastContainer } from 'react-toastify'
import { useDispatch, useSelector } from 'react-redux'
import { withRouter } from 'react-router-dom'
import SingleContactDetails from './single-contact-details'
import { SolidButton, TransparentButton } from '../../../../library/button'
import { changeSingleContactListModal, resetEditContactDisplay, updateSingleContactDisplay } from '../../../../../redux/actions/single-contact-list'
import { auth } from '../../../../../networking/firebase'
import { Popup } from '../../../../library/popup'
import './style.scss'

const Index = props => {

    const dispatch = useDispatch()

    const listId = props.match.params.id

	const updateLoading = useSelector(state => state.singleContactList.updateSingleRecord.loading)
    const modalState = useSelector(state => state.singleContactList.showModals.editSingleModal)

    const selectedCompany = useSelector(state => state && state.activeCompany && state.activeCompany.activeCompany && state.activeCompany.activeCompany.id)
	const activeContact = useSelector(state => state.singleContactList.activeEdit)

    const [singleContact, setSingleContact] = useState({
        addedBy: auth.currentUser.uid,
		logoUrl: null,
		general: {
			firstName: null,
			lastName: null
		},
		contact: {
			phone: null,
			email: null,
			website: null
		},
        company:{
            name: null,
            position: null
        },
		social: {
			twitter: null,
			facebook: null
		},
		address: {
			street: null,
			postalCode: null,
			city: null,
		},
    })

    const handleClose = () => {
        dispatch(changeSingleContactListModal({editSingleModal: false}))
		dispatch(resetEditContactDisplay())
    }

    const clickUpdateContact = () => {
	   dispatch(updateSingleContactDisplay({companyId: selectedCompany, listId: listId, record: singleContact}))
    }

	useEffect(() => {
		if(Object.keys(activeContact).length > 0){
			setSingleContact(activeContact)
		}
	}, [activeContact])

	return(
		<Popup
			onClose={handleClose}
			show={modalState} 
			title="Endre kontakt"
			description="Du kan redigere all informasjon om den spesifikke kontakten din i skjemaet nedenfor."
			buttons={[
				<TransparentButton title="Avbryt" type="button" data-dismiss="modal" onClick={() => handleClose()} />,
				<SolidButton color="blue" title={updateLoading ? "Oppdaterer..":"Oppdater"} onClick={() => clickUpdateContact()} icon={updateLoading ? <i className="fas fa-circle-notch fa-spin"></i>:<i className="fas fa-sync"></i>} type="button"/>
			]}	
		>
			<div className="edit-single-content-container">
				<SingleContactDetails singleContact={singleContact} setSingleContact={setSingleContact}/>
			</div>
			<ToastContainer/>
		</Popup>
	)
}

export default withRouter(Index)